import React from "react";
import { LoadingIcon } from "../../../components/Loading";

export function KeylessButton({
  text,
  color = "#5B5B5B",
  backgroundColor,
  onClick,
  isLoading,
  disabled,
  style,
}) {
  return (
    <button
      onClick={onClick}
      style={{
        color: color,
        backgroundColor: backgroundColor,
        pointerEvents: disabled || isLoading ? "none" : "auto",
        opacity: disabled ? 0.5 : 1,
        ...buttonStyle,
        ...style,
      }}
    >
      {isLoading ? <LoadingIcon /> : null}
      {text}
    </button>
  );
}

const buttonStyle = {
  width: "100%",
  height: '6vh',
  borderRadius: "20px",
  fontSize: "1.2rem",
  outline: "none",
  border: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "1rem",
};
